// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hrrnkhepnrypbqorqgyc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhycm5raGVwbnJ5cGJxb3JxZ3ljIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA0ODQwNzEsImV4cCI6MjA4NjA2MDA3MX0.0AQ9bL01zIneAVJKiAuu3tglmNwePiKtnqeQYHvlQ-M";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});